import { AuthClientProvider } from "@/shared/lib/authClient";
import { queryClientConfig } from "@/shared/lib/trpcClient";
import type { AppPropsWithLayout } from "@/shared/lib/types/layoutTypes";
import "../styles/globals.css";
import { ThemeProvider } from "@/components/ui/theme-provider";
import { HydrationBoundary, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Geist_Mono, Poppins } from "next/font/google";
import { useState } from "react";

const popinsSans = Poppins({
	weight: ["400", "500", "600", "700", "800"],
	variable: "--font-popins-sans",
	subsets: ["latin"]
});

const geistMono = Geist_Mono({
	variable: "--font-geist-mono",
	subsets: ["latin"]
});

export default function App({ Component, pageProps }: AppPropsWithLayout) {
	const getLayout = Component.getLayout ?? ((page) => page);
	const [client] = useState(() => new QueryClient(queryClientConfig));
	return (
		<div
			className={`${popinsSans.variable} ${geistMono.variable} flex h-screen w-full flex-col`}
		>
			<QueryClientProvider client={client}>
				<ThemeProvider>
					<ReactQueryDevtools initialIsOpen={false} />
					<AuthClientProvider>
						<HydrationBoundary state={pageProps.dehydratedState}>
							{getLayout(<Component {...pageProps} />)}
						</HydrationBoundary>
					</AuthClientProvider>
				</ThemeProvider>
			</QueryClientProvider>
		</div>
	);
}
